
import { useNavigate, useLocation } from "react-router-dom";
import { Shell } from "@/components/layout/Shell";
import { QuickAddContractForm } from "@/components/contracts/quick-add/QuickAddContractForm";
import { useEnhancedTranslation } from "@/hooks/useEnhancedTranslation";

export default function QuickAddContractPage() {
  const { t } = useEnhancedTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const returnPath = new URLSearchParams(location.search).get("returnTo") || "/contracts";
  
  const handleSuccess = () => {
    navigate(returnPath);
  };
  
  const handleCancel = () => {
    navigate(returnPath);
  };
  
  return (
    <Shell>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">{t('quickAddContract', 'Quick Add Contract')}</h1>
          <p className="text-muted-foreground mt-2">
            {t('quicklyAddEssentialContractDetails', 'Quickly add essential contract details. Optional fields can be updated later.')}
          </p>
        </div>
        
        <QuickAddContractForm 
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </div>
    </Shell>
  );
}
